'use es6';

import { Map as ImmutableMap } from 'immutable';
import extractor from '../../../../config/extractor';
const getDateRange = (config, missing) => config.getIn(['filters', 'dateRange']) || missing;
export default (() => extractor(getDateRange, ImmutableMap({
  value: ImmutableMap({
    rangeType: 'ALL'
  })
})));